'use client';

import React, { useState } from 'react';
import { RxCaretRight, RxCaretDown } from 'react-icons/rx';
import Markdown from '../Markdown';
import { H2 } from '../WebsiteTypography';
import styles from './styles.module.scss';

const leftWidth = 36;
const iconSize = 30;

const FaqItem = props => {
  const [collapse, toggleCollapse] = useState(true);
  return (
    <div>
      <div
        style={{ display: 'flex', cursor: 'pointer', userSelect: 'none' }}
        onClick={e => {
          e.preventDefault();
          toggleCollapse(!collapse);
        }}
      >
        <div style={{ width: leftWidth, paddingTop: 1 }}>
          {!collapse ? <RxCaretDown size={iconSize} /> : <RxCaretRight size={iconSize} />}
        </div>
        <div className={styles.title}>{props.title}</div>
      </div>

      {!collapse && (
        <div
          style={{
            fontFamily: 'Inter',
            fontSize: 15,
            textAlign: 'left',
            display: 'flex',
            color: '#ffffffde',
          }}
        >
          <div style={{ width: leftWidth }} />
          <div style={{ flex: 1 }}>
            <Markdown>{props.description}</Markdown>
          </div>
        </div>
      )}
    </div>
  );
};

const Faq = props => {
  if (props.config?.faq.length === 0) {
    return;
  }
  return (
    <div className={styles.faq} id="faq">
      <div className={styles.faqInner}>
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <H2>FAQ</H2>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            marginTop: 30,
          }}
        >
          {props?.faq.map((item, i) => {
            return <FaqItem key={i} {...item} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Faq;
